import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=25d801c8&scoped=true&"
import script from "./registerForm.vue?vue&type=script&lang=ts&"
export * from "./registerForm.vue?vue&type=script&lang=ts&"
import style0 from "./registerForm.vue?vue&type=style&index=0&id=25d801c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d801c8",
  null
  
)

export default component.exports